import React, { useEffect, useRef, useState } from "react";
import { Nav, NavItem, Navbar } from "react-bootstrap";
import { NavLink, NavLink as ReactLink, useNavigate } from "react-router-dom";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Typed from "typed.js";
import {
  doLogout,
  getNetWorthFromLocal,
  getNetworth,
  getUser,
  setNetWorthInLocal,
} from "../../services/user-service";
import Networthpopup from "../popup/networth-popup";
import "./UserNavbar.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { blacklist } from "validator";

const useNetWorth = () => {
  const [networth, setNetworth] = useState("");
  const [category, setCategory] = useState([]);
  const [coins, setCoins] = useState([]);
  const [netEstimatedValue, setNetEstimatedValue] = useState(0);

  const fetchNetworth = () => {
    const id = getUser().commonId;
    const localStorageNetWorth = getNetWorthFromLocal();
    setNetworth(localStorageNetWorth);
    if (localStorageNetWorth === null) {
      getNetworth(id)
        .then((data) => {
          setNetworth(data.TotalNetWorth);
          setNetWorthInLocal(data.TotalNetWorth);
          const networth = data.TotalNetWorth;
        })
        .catch((error) => {});
    }
  };

  

  const calculateEstimatedValue1 = (coin1, quntity) => {
    const filteredCoins = coins.filter((coin) => coin.name === coin1);
    if (filteredCoins.length > 0) {
      return parseInt(quntity) * filteredCoins[0].current_price;
    } else {
      return 0;
    }
  };

  const calculateNetEstimatedValue = () => {
    let totalValue = 0;
    for (const row of category) {
      totalValue += calculateEstimatedValue1(row.coin, row.quntity);
    }
    return totalValue;
  };

  useEffect(() => {
    fetchNetworth();
  
  }, []);

  useEffect(() => {
    const totalValue = calculateNetEstimatedValue();
    setNetEstimatedValue(totalValue);
  }, [category, coins]);

  return { networth, netEstimatedValue };
};

const UserNavbar = () => {
  const { networth, netEstimatedValue } = useNetWorth();
  const user = getUser(); 
  const navigate = useNavigate(); 

  const logout = () => {
    doLogout();
    navigate("/");
  };
  if (netEstimatedValue !== 0) {
    const totalNetWorth = networth + netEstimatedValue;
    setNetWorthInLocal(totalNetWorth);
  }

  const formattedTotalNetWorth = Number.parseFloat(
    getNetWorthFromLocal()
  ).toFixed(2);

  const [isPopupOpen, setPopupOpen] = useState(false);
  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };
  const popupRef = useRef(null);

  const handleOutsideClick = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setPopupOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const [imageSrc, setImageSrc] = useState("");
const base64ToImage = () => {
  const base64String = user.image;
  if (typeof base64String === "string" && base64String.trim()) {
    setImageSrc(`data:image/jpeg;base64,${base64String.trim()}`);
  } else {
    setImageSrc(`${process.env.PUBLIC_URL}/img/avtar.jpg`);
  }
};

useEffect(() => {
  base64ToImage();
}, [user]);
  const el = useRef(null);

  function addCommasToNumber(number) {
    let numberStr = number.toString();
    numberStr = numberStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return numberStr;
  }
  let formattedNetworthValue = addCommasToNumber(formattedTotalNetWorth);

  const [isPopupNetworthOpen, setIsNetworthPopupOpen] = useState(false);

  const toggleNetworthPopup = () => {
    setIsNetworthPopupOpen(!isPopupNetworthOpen);
  };

  return (
    <div>
      <Navbar className="navbar " expand="lg" bg="dark" variant="dark">
        <Navbar.Brand className="navbar-logo">
          <NavLink tag={ReactLink} to="/user/dashboard">
            <LazyLoadImage
              className="navbar_logo_image"
              src={`${process.env.PUBLIC_URL}/logo192.webp`}
              alt="logoPng"
            />
          </NavLink>
        </Navbar.Brand>
      

        <Navbar.Toggle
          className="navbar-toggler"
          aria-controls="basic-navbar-nav"
          style={{ marginRight: "20px" }}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Link
              className="navname navbar_link"
              smooth="true"
              duration={50}
              tag={ReactLink}
              to="/user/dashboard"
            >
              Dashboard
            </Link>

            <Link
              className="navname navbar_link"
              smooth="true"
              duration={50}
              tag={ReactLink}
              to="/user/why-I-Chest"
            >
              Why I-Chest
            </Link>

            <Link
              className="navname navbar_link"
              smooth="true"
              duration={50}
              tag={ReactLink}
              to="/user/legacy-Chart"
            >
              Legacy chart
            </Link>

            <Link
              className="navname navbar_link"
              smooth="true"
              duration={50}
              tag={ReactLink}
              to="/user/owner"
            >
              Owners
            </Link>
            <Link
              className="navname navbar_link"
              smooth="true"
              duration={50}
              tag={ReactLink}
              to="/user/trust"
            >
              Trusts
            </Link>
            <Link
              className="navname navbar_link"
              smooth="true"
              duration={50}
              tag={ReactLink}
              to="/user/attorney"
            >
              Attorneys/Agents
            </Link>

            <Link
              className="navname navbar_link"
              smooth="true"
              duration={50}
              tag={ReactLink}
              to="/user/beneficiary"
            >
              Beneficiaries
            </Link>

            <Link
              className="navname navbar_link"
              smooth="true"
              duration={50}
              tag={ReactLink}
              to="/user/help"
              >
                Help
              </Link>
          </Nav>
          <Nav navbar>
           
            <NavItem>
              <NavLink onClick={togglePopup} className="nav-user-name">
                <img
                    src={imageSrc}
                    alt="avatar_image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `${process.env.PUBLIC_URL}/img/avtar.jpg`;
                    }}
                  />
                <div className="navbar_username ">
                  {user.firstName + " "}
                  {user.lastName}
                </div>

                <FontAwesomeIcon
                  style={{ marginLeft: "10px" }}
                  icon={faCaretDown}
                />
              </NavLink>
            </NavItem>
           {isPopupOpen && (
            <div ref={popupRef} className="popup1">
              <ul>
                <Link to="/user/profile" className="navbar_link">
                  Profile
                </Link>
                <Link to="/user/dashboard" className="navbar_link">
                  Dashboard
                </Link>
                <Link to="/user/help" className="navbar_link">
                  Help
                </Link>
                <a style={{ color: "#5e6576" }} onClick={logout}>
                  Logout
                </a>
              </ul>
            </div>
          )}

          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};
export default UserNavbar;
